 
import { getAuth, initializeAuth, browserSessionPersistence, connectAuthEmulator } from 'firebase/auth';

/**
 * Detect whether this tab is an impersonation tab (education-only concern).
 * Duplicated from @repo/stores/storage.js to avoid circular dependencies.
 * Exported so the Firestore layer can keep impersonation tabs memory-only.
 */
export function isImpersonationTab() {
    if (typeof window === 'undefined') return false;
    try {
        if (new URL(window.location.href).searchParams.has('impersonate')) return true;
        const ghost = sessionStorage.getItem('ghostToken');
        return ghost !== null && ghost !== 'null';
    } catch { return false; }
}

/**
 * Create a Firebase Auth instance.
 *
 * @param {import('firebase/app').FirebaseApp} firebase
 * @param {object} [opts]
 * @param {boolean} [opts.enableImpersonation] - If true, impersonation tabs
 *   use session-only persistence (isolates auth state per tab).
 *   Only the education app needs this.
 * @returns {import('firebase/auth').Auth}
 */
export function createAuth(firebase, { enableImpersonation = false } = {}) {
    const auth = enableImpersonation && isImpersonationTab()
        ? initializeAuth(firebase, { persistence: browserSessionPersistence })
        : getAuth(firebase);

    if (import.meta.env.DEV) {
        const host = import.meta.env.VITE_EMULATOR_HOST || 'localhost';
        const port = Number(import.meta.env.VITE_EMULATOR_PORT_AUTH) || 9099;
        const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'https' : 'http';
        connectAuthEmulator(auth, `${protocol}://${host}:${port}`);
    }

    return auth;
}
